/*
 * SPDX-FileCopyrightText: 2023 SAVIA Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

export const asm = {
  asm: {
    customerSearch: {
      submit: 'Iniciar sésion',
    },
    bindCart: {
      cartNumber: 'Número del Carro',
      bindCartToCustomer: 'Asignar carrito al cliente'
    },
    startCustomerEmulationAlertInfo: 'La emulación del cliente ha comenzado. Cualquier acción que realice afectará la cuenta del cliente.',
    asmCustomer360Button: "Vista del Cliente 360°",
    mainLogoLabel: 'SAVIA',
    mainTitle: 'Modo de servicio asistido',
    logout: 'Cerrar sesión',
    hideUi: 'Cerrar ASM',
    helpPortalUrl: 'Ayuda',
    customers: 'Clientela',
    createClienteSuccessfullyAlert:
      'Se ha creado la cuenta de cliente y se ha iniciado la sesión de cliente.',
    saveInactiveCarroAlertInfo:
      'El carrito identificado es un carrito inactivo. Para realizar más acciones en este carrito, guárdelo primero.',
    activeCarroAlertInfo: 'El carro identificado es un carro activo.',
    startClienteEmulationAlertInfo:
      'La emulación del cliente ha comenzado. Cualquier acción que realice reflejará los efectos en la cuenta del cliente.',
    toggleUi: {
      collapse: 'Ocultar ASM',
      expand: 'Mostrar ASM',
    },
    loginForm: {
      submit: 'Iniciar sesión',
      userId: {
        label: 'IDENTIFICACIÓN de agente',
        required: 'Se requiere identificación de agente',
      },
      password: {
        label: 'Contraseña',
        required: 'Se requiere contraseña',
      },
    },
    customerBuscar: {
      searchTerm: {
        label: 'Cliente Nombre/Dirección de correo electrónico',
      },
      submit: 'Iniciar sesión',
      startEmulation: 'Iniciar emulación',
      noMatch: 'No se ha encontrado ningún cliente.',
      noMatchResult: 'Esta cuenta no se puede encontrar.',
      createCliente: 'Crear nuevo cliente',
    },
    createClienteForm: {
      title: 'Crear nuevo cliente',
      createCuenta: 'Crear',
      cancel: 'Cancelar',
      firstNombre: {
        label: 'Nombre',
        placeholder: 'Nombre',
      },
      lastNombre: {
        label: 'Apellido',
        placeholder: 'Apellido',
      },
      emailAddress: {
        label: 'Dirección de correo electrónico',
        placeholder: 'Dirección de correo electrónico',
      },
      createCuentaAlert:
        'La sesión de cliente se inicia una vez que crea la cuenta de cliente.',
      validationErrors: {
        firstNombre: 'Introduzca un nombre válido.',
        lastNombre: 'Introduzca un apellido válido.',
        emailAddress: 'Introduzca una dirección de correo electrónico válida.',
      },
      badRequestDuplicatedEmail:
        'Introduzca una dirección de correo electrónico diferente, ya que {{ emailAddress }} ya existe.',
    },
    customerList: {
      oneCustomer: '1 Cliente',
      noOfCustomers: '{{count}} Clientes',
      title: 'Lista de clientes',
      description: 'Seleccione un cliente de una de las varias listas proporcionadas.',
      createCliente: 'Crear nuevo cliente',
      cancel: 'Cancelar',
      tableHeader: {
        customer: 'Cliente',
        customerName: 'Cliente Nombre',
        name: 'Nombre',
        email: 'Correo electrónico',
        emailId: 'Correo electrónico/IDENTIFICACIÓN',
        b2bUnitName: 'Nombre Cliente',
        b2bUnitCode: 'Cliente',
        cif: 'CIF',
        poblacion: 'Población',
        phone: 'Teléfono',
        account: 'Cuenta',
        cart: 'Carro',
        order: 'Orden',
        view: 'Vista 360',
      },
      tableSort: {
        sortBy: 'Ordenar por',
        byNombre: 'Nombre (Asc)',
        byNombreAsc: 'Nombre (Asc)',
        byNombreDesc: 'Nombre (Desc)',
        byDateAsc: 'Fecha (Asc)',
        byDateDesc: 'Fecha (Desc)',
        byOrdenDateAsc: 'Orden de fecha (Asc)',
        byOrdenDateDesc: 'Orden de fecha (Desc)',
        byUnit: 'Cuenta (Asc)',
        byUnitDesc: 'Cuenta (Desc)',
      },
      page: {
        page: 'Página {{count}}',
        previous: 'Anterior',
        next: 'Próximo',
      },
      noOfClientela: '{{count}} Clientela',
      oneCliente: '1 Cliente',
      noClientela: 'Actualmente no hay clientes en esta lista de clientes.',
      noLists:
        'Actualmente no hay listas de clientes disponibles. Póngase en contacto con el administrador del sistema.',
      listsError:
        'No se han podido recuperar las listas de clientes. Por favor, inténtelo de nuevo más tarde.',
      searchBox: 'Buscar',
      enterBuscarBox: 'Ingrese el nombre o el correo electrónico del cliente',
    },
    switchCliente: {
      dialog: {
        title: 'Advertencia',
        body: 'Clicking "Conmutador de cliente" will end the emulation for "{{ customerA }}" and start for "{{ customerB }}". Any unsaved changes for "{{ customerA }}" will be lost.',
        actions: {
          switch: 'Conmutador de cliente',
        },
      },
    },
    saveCarro: {
      saveCarroBtn: 'Guardar para más tarde',
      dialog: {
        saveInfo: 'Guarde el carrito antes de poder realizar más acciones.',
        disableInfo: 'No se puede guardar el carrito porque está vacío.',
        title: 'Guardar Carro',
        row: {
          id: 'IDENTIFICACIÓN',
          qty: 'Cantidad',
          total: 'Total',
        },
        actions: {
          save: 'Guardar para más tarde',
        },
      },
    },
    bindCarro: {
      cartNumber: 'Número de Carro',
      bindCarroToCliente: 'Asignar coche al cliente',
      success: 'Carro ha sido asignado con éxito',
      assignCarroId: 'Asignar un ID de carrito al cliente',
      enterCarroId: 'Introduzca el ID del carrito',
      resetCarroId: 'Restablecimiento',
      dialog: {
        title: 'Asignar Carro Anónimo',
        body: 'Do you want to replace the current active cart with the anonymous cart? If you replace the current active cart, it is saved as a saved cart.',
        actions: {
          replace: 'Reemplace a Carro',
        },
      },
    },
    csagentTokenExpired: 'La sesión del agente de atención al cliente ha caducado.',
    endSession: 'Fin de sesión',
    endEmulation: 'Emulación final',
    agentSessionTimer: {
      label: 'Tiempo de espera de la sesión',
      minutes: 'min',
      reset: 'Restablecimiento',
    },
    auth: {
      agentLoggedInError:
        'No se puede iniciar sesión como usuario cuando hay una sesión activa del agente de CS. Emule al usuario o cierre la sesión del agente CS.',
    },
    error: {
      noClienteId:
        'No se encontró ningún customerId para el usuario seleccionado. No se puede iniciar la sesión.',
    },
  },
};
